<div class="modal modal-alert in" style="display: block;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i
            [class.text-danger]="type === 'DANGER'"
            [class.text-warning]="type === 'WARNING'"
            class="fa-solid"
            [ngClass]="titleIcon"
          ></i>
          <small class="m-l-sm"><strong>{{ title | translate }}</strong></small>
        </h5>
      </div>
      <div class="modal-body">
        <gp-message *ngIf="isCopied"
                    class="text-center"
                    text="ERROR.copied_to_clipboard_success_msg" type="success"></gp-message>
        <p *ngIf="withIllustration" class="text-center illustration">
          <img src="assets/images/illustration_state_error1.svg" alt="404"/>
        </p>
        <p class="m-0"
           [class.font-weight-bold]="noDetails() && withIllustration"
           [class.text-center]="noDetails() && withIllustration"
           [class.text-md]="noDetails() && withIllustration">{{ description | translate }}</p>
        <div *ngIf="!noDetails()" class="alert alert-warning m-b-0">
          <ng-container *ngIf="details.length == 1; else moreDetails">
            <span>{{ details[0] | translate }}</span>
          </ng-container>
          <ng-template #moreDetails>
            <ul class="m-0">
              <li *ngFor="let detail of details">
                {{ detail | translate }}
              </li>
            </ul>
          </ng-template>
        </div>
        <p *ngIf="technicalDetailsForCopy"
           class="text-muted text-center m-b-0 m-t-1">{{ 'ERROR.copy_details_instruction_msg' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button *ngIf="technicalDetailsForCopy"
                type="button"
                test-id="copyErrorLink"
                class="btn btn-outline-default p-x-md m-r-sm"
                (click)="copyToClipboard()">
          <i class="fa fa-light fa-clipboard" aria-hidden="true"></i>
          {{ 'ERROR.copy_details' | translate }}
        </button>
        <button type="button" class="btn p-x-md" (click)="done()"
                [ngClass]="{
          'btn-danger': type === 'DANGER',
          'btn-dark': type ==='WARNING'
        }">OK
        </button>
      </div>
    </div>
  </div>
</div>
